export default __webpack_public_path__ + "static/media/ic_location_pin.381f17d5.svg";